import request from '../utils/http'
// 列表 (记录)
export function index (query) {
  return request({
    url: '/process/index',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/process.js